import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

/** One headline number. With `to` the whole tile opens the section it summarizes. */
export function StatTile({
  label,
  value,
  detail,
  to,
  className,
}: {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  to?: string;
  className?: string;
}) {
  const body = (
    <>
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <p className="mt-1.5 text-2xl font-semibold tracking-tight tabular-nums text-foreground">{value}</p>
      {detail ? <p className="mt-1 truncate text-xs text-muted-foreground">{detail}</p> : null}
    </>
  );
  const tileClass = cn('block rounded-xl border border-border bg-card p-4', className);
  return to ? (
    <Link to={to} className={cn(tileClass, 'transition-colors hover:border-foreground/20 hover:bg-muted/30')}>
      {body}
    </Link>
  ) : (
    <div className={tileClass}>{body}</div>
  );
}
